/* Elevate PDP: desktop purchase bar (round 4).
   On screens 1000px and wider, shows the existing .sticky bar as a floating pill at the bottom of the screen
   once the main Add to cart button has scrolled out of view, and hides it again over the closing section.
   Mobile is untouched: the class only has an effect inside the desktop media query in elevate-desktop.css. */
(function () {
  'use strict';
  var root = document.querySelector('.ew-approved');
  var cta = document.getElementById('main-cta');
  var closing = document.querySelector('main .closing');
  if (!cta || !('IntersectionObserver' in window)) return;
  /* Add the product thumbnail and name to the bar (shown on desktop only) */
  var bar = document.querySelector('.sticky');
  if (bar && !bar.querySelector('.ew-bar-product')) {
    var data = {}; try { data = JSON.parse(document.getElementById('product-data').textContent); } catch (e) {}
    var main = document.getElementById('main-image');
    var box = document.createElement('div'); box.className = 'ew-bar-product';
    if (main && main.getAttribute('src')) { var img = document.createElement('img'); img.src = main.getAttribute('src'); img.alt = ''; box.appendChild(img); }
    var name = document.createElement('span'); name.textContent = data.name || document.title.split('·')[0].trim(); box.appendChild(name);
    bar.insertBefore(box, bar.firstChild);
  }
  var ctaVisible = true, closingVisible = false;
  function update() { root.classList.toggle('ew-bar', !ctaVisible && !closingVisible && window.scrollY > 200); }
  new IntersectionObserver(function (e) { ctaVisible = e[0].isIntersecting; update(); }, { threshold: 0 }).observe(cta);
  if (closing) new IntersectionObserver(function (e) { closingVisible = e[0].isIntersecting; update(); }, { threshold: 0 }).observe(closing);
  window.addEventListener('scroll', update, { passive: true });
})();
